import React, { useState } from "react";
import packageJson from "../../../package.json"

// @components
import {
  Card,
  Input,
  Button,
  CardBody,
  Typography,
} from "@material-tailwind/react";
import imageLogo from "../../assets/logo_ticket_win.png";
import "./index.css";
import { createUserWithEmailAndPassword, fetchSignInMethodsForEmail } from "firebase/auth";
import { authFB } from "../../firebase";
import { Notyf } from "notyf"; // Importa Notyf
import 'notyf/notyf.min.css'; // Asegúrate de importar el CSS de Notyf

const notyf = new Notyf(); // Inicializa Notyf

function SignUp() {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSignUp = async (e) => {
    e.preventDefault();
    
    // Validación de campos
    if (!nombre || !apellido || !email || !password) {
      notyf.error("Por favor, completa todos los campos.");
      return;
    }
  
    try {
      // Comprobar si el correo ya está registrado
      const signInMethods = await fetchSignInMethodsForEmail(authFB, email);
      if (signInMethods.length > 0) {
        notyf.error("Este correo ya está registrado. Intenta con otro.");
        return;
      }
  
      // Crear usuario
      await createUserWithEmailAndPassword(authFB, email, password);
      notyf.success("¡Registro exitoso!");
      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    } catch (error) {
      console.error("Error signing up:", error);
      notyf.error("Error al registrarse: " + error.message);
    }
  };

  return (
    <section>
      <div className="mx-auto h-full grid place-items-center bg-colors-container">
        <Card shadow={false} className="py-8 border border-gray-300">
          <div className="flex justify-center align-center flex-col px-6 text-center">
            <div className="flex justify-center">
              <img src={imageLogo} alt="TicketWin APP" width={"250px"} />
            </div>
            <Typography
              variant="h1"
              color="blue-gray"
              className="mt-4 mb-2 !text-2xl lg:text-4xl"
            >
              Crear cuenta Ticket Win
            </Typography>
            <Typography className="!text-gray-600 text-[16px] font-normal md:max-w-lg">
              Organiza y participa en rifas de forma fácil y rápida. ¡Crea sorteos o adquiere tus tickets en segundos!
            </Typography>
          </div>

          <CardBody>
            <form action="#" className="flex flex-col gap-4" onSubmit={handleSignUp}>
              <div className="flex gap-4">
              <div className="w-full">
                <label htmlFor="nombre">
                  <Typography variant="small" color="blue-gray" className="block font-medium mb-2">
                    Nombre
                  </Typography>
                </label>
                <Input
                  id="nombre"
                  color="gray"
                  size="lg"
                  type="text"
                  name="nombre"
                  placeholder="Tu nombre"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  className="w-full placeholder:opacity-100 focus:border-t-primary border-t-blue-gray-200"
                  labelProps={{ className: "hidden" }}
                />
              </div>
              <div className="w-full">
                <label htmlFor="apellido">
                  <Typography variant="small" color="blue-gray" className="block font-medium mb-2">
                    Apellido
                  </Typography>
                </label>
                <Input
                  id="apellido"
                  color="gray"
                  size="lg"
                  type="text"
                  name="apellido"
                  placeholder="Tu apellido"
                  value={apellido}
                  onChange={(e) => setApellido(e.target.value)}
                  className="w-full placeholder:opacity-100 focus:border-t-primary border-t-blue-gray-200"
                  labelProps={{ className: "hidden" }}
                />
              </div>
              </div>
            
              <div className="w-full">
                <label htmlFor="email">
                  <Typography variant="small" color="blue-gray" className="block font-medium mb-2">
                    Tu correo
                  </Typography>
                </label>
                <Input
                  id="email"
                  color="gray"
                  size="lg"
                  type="email"
                  name="email"
                  placeholder="name@mail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full placeholder:opacity-100 focus:border-t-primary border-t-blue-gray-200"
                  labelProps={{ className: "hidden" }}
                />
              </div>
              <div className="w-full">
                <label htmlFor="password">
                  <Typography variant="small" color="blue-gray" className="block font-medium mb-2">
                    Contraseña
                  </Typography>
                </label>
                <Input
                  id="password"
                  color="gray"
                  size="lg"
                  type="password"
                  name="password"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full placeholder:opacity-100 focus:border-t-primary border-t-blue-gray-200"
                  labelProps={{ className: "hidden" }}
                />
              </div>
              <Button type="submit" size="lg" color="gray" fullWidth>
                Registrarse
              </Button>
              <Typography
                variant="small"
                className="text-center mx-auto max-w-[19rem] !font-medium !text-gray-600"
              >
                Ya tengo una cuenta{" "}
                <a href="/login" className="text-black text-bold">
                  <strong><u>  Acceder a Mis Rifas </u></strong>
                </a>{" "}
              </Typography>
              <Typography
                variant="small"
                className="text-center mx-auto max-w-[19rem] !font-medium !text-gray-600"
              >
                Al registrarte, aceptas nuestros{" "}
                <a href="/terms-conditions" className="text-blue-800">
                  Términos de Servicio
                </a>{" "}
                &{" "}
                <a href="/terms-conditions" className="text-blue-800">
                  Política de Privacidad.
                </a>
              </Typography>
              <small>v{packageJson.version}</small>
            </form>
          </CardBody>
        </Card>
      </div>
    </section>
  );
}

export default SignUp;
